export default __webpack_public_path__ + "static/media/ysd-004-ad1.7a4362f3.jpg";